import { recStatusModify } from "../../../../../../../utils/rec-status.modify"

export const modifyForm = async (data: any) => {
    await data.forEach((value: any) => {
        value.prCARecStatus = recStatusModify.table(value.prCARecStatus)
    })
    return data
}